var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorialIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.731,
    height: 101.48,
    viewBox: "0 0 113.731 101.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    transform: "translate(-49.987 -4896.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M109.272 4900.6c-21.158-11.758-36.494 6.185-53 17.436 19.5 39.1 86.4 39.22 106 0-16.506-11.249-31.843-29.192-53-17.436z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    fill: "#041e42",
    fillRule: "evenodd",
    d: "M104.272 4905.6c-21.158-11.758-36.494 6.185-53 17.436 19.5 39.1 86.4 39.221 106 0-16.506-11.249-31.843-29.192-53-17.436zm0 28s-19.341.619-27.293-8.252l-.015-.017c8.644-3.479 17.9-7.808 27.309-4.6 9.493-3.2 18.6 1.11 27.309 4.6-7.944 8.896-27.31 8.276-27.31 8.276z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M104.284 4953.408h-.033c-24.031-.011-44.675-11.477-53.874-29.923l-.39-.781.721-.492c2.978-2.029 5.979-4.326 8.881-6.546 13.291-10.171 27.032-20.685 44.682-11.2 17.653-9.482 31.393 1.033 44.683 11.2 2.9 2.22 5.9 4.517 8.881 6.546l.722.492-.391.782c-9.227 18.458-29.871 29.921-53.882 29.922zm-51.723-30.043c9.047 17.31 28.762 28.032 51.69 28.043h.033c22.91 0 42.624-10.72 51.7-28.043-2.779-1.931-5.553-4.053-8.242-6.111-13.495-10.326-26.238-20.083-42.982-10.778l-.486.27-.485-.27c-16.742-9.3-29.486.451-42.982 10.778-2.693 2.058-5.466 4.181-8.246 6.111zm52.662 11.255c-.5 0-.825-.008-.952-.012-1.181.037-19.954.431-28.037-8.586l-.952-1.063 3.219-1.324c8.267-3.37 16.811-6.853 25.771-3.95 8.976-2.884 17.43.558 25.609 3.886.692.282 1.384.563 2.071.839l1.324.53-.95 1.064c-7.209 8.068-22.969 8.616-27.103 8.616zm-.952-2.013h.033c.175 0 17.425.458 25.508-6.906-.228-.093-.457-.185-.685-.279-7.939-3.229-16.147-6.57-24.536-3.737l-.321.108-.321-.109c-8.372-2.854-16.667.531-24.694 3.8l-.522.212c8.123 7.363 25.329 6.914 25.506 6.909z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    width: 39.742,
    height: 17.5,
    fill: "#041e42",
    rx: 4,
    transform: "translate(92.307 4979.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M128.049 4998.24H96.308a5.006 5.006 0 0 1-5-5v-9.5a5.005 5.005 0 0 1 5-5h31.741a5.005 5.005 0 0 1 5 5v9.5a5.006 5.006 0 0 1-5 5zm-31.741-17.5a3 3 0 0 0-3 3v9.5a3 3 0 0 0 3 3h31.741a3 3 0 0 0 3-3v-9.5a3 3 0 0 0-3-3z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M144.794 4989.253a1 1 0 0 1-.4-1.919c9.291-4 14.718-8.62 16.589-14.107 2.193-6.433-.979-13.48-3.987-18.9a1 1 0 1 1 1.748-.971c3.209 5.783 6.579 13.341 4.132 20.518-2.064 6.053-7.85 11.057-17.691 15.3a.978.978 0 0 1-.391.079z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M155.761 4958.337l-4.307-15.11 11.287 10.932z",
    className: "cls-3"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon1);
export default __webpack_public_path__ + "static/media/tutorial-icon-1.8ba155b40b5b4c0e6d2d82fe975d8fbf.svg";
export { ForwardRef as ReactComponent };